module.exports = __webpack_public_path__ + "static/media/infoWhiteFull.ba412807.svg";